import React from "react";

function Footer() {
  return (
    <>
      <section className="footer  position-relative" id="contact">
        <div className="container">
          <div className="row pb-md-5 pb-3">
            <div className="col-md-4">
              <img
                src="/assets/img/logo.png"
                alt="Logo"
                className="footer_logo mb-4"
              />
               
             <div className="social_icon ms-2"><a target="_blank" href="https://x.com/MyTraDeFi"><i className="bi bi-twitter-x"></i></a><a target="_blank" href="https://www.instagram.com/mytradefi"><i className="bi bi-instagram"></i></a><a target="_blank" href="https://t.me/mytradefi"><i className="bi bi-telegram"></i></a></div>
            </div>
         
                <div className="col-md-5 col-lg-4 contact ms-auto">
                  <h5>Contact</h5>
                  <ul className="footer_manu"><li><i className="bi bi-pin-map"></i>NeoTech Automations FZ-LLC<br/>VUPR0773<br/>Compass building - Al Hulaila, AL Hulaila Industrial Zone-FZ, Ras Al Khaimah, United Arab Emirates<br/></li><li><i className="bi bi-envelope"></i> <a href="mailto:info@mytradefi.io">info@mytradefi.io</a></li></ul>
                </div>
            
          </div>

          <h6 className="mt-3">Disclaimer</h6>
          <p className="mb-5">
            Trading derivatives carries significant risks. It is not suitable
            for all investors and if you are a professional client, you could
            lose substantially more than your initial investment. When acquiring
            our derivative products, you have no entitlement, right or
            obligation to the underlying financial assets. Past performance is
            no indication of future performance and tax laws are subject to
            change. The information on this website is general in nature and
            doesn't take into account your personal objectives,
          </p>
          <hr />
          <div className="copy-right text-center pb-3  ">
            {" "}
            <small className="fw200">
              {" "}
              © 2025 by NeoTech Automations FZ LLC. All rights reserved!
            </small>
          </div>
        </div>
      </section>
    </>
  );
}

export default Footer;
